<template>
    <v-snackbar
            v-model="snackbar.active"
            :color="snackbar.type"
            :timeout="-1"
    >
        {{ snackbar.message }}
    </v-snackbar>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'Snackbar',
        computed: {
            ...mapGetters([
                'snackbar'
            ])
        }
    }
</script>
